import Vue from 'vue'
import './config'
const JsEncryptModule = require('jsencrypt')


Vue.use((V) => {

  /**
   * RSA 加密
   */
  V.prototype.$encrypt = (text) => {
    const encrypt = new JsEncryptModule.JSEncrypt
    encrypt.setPublicKey(RSA_PUBLIC_KEY);
    return encrypt.encrypt(text);
  }
});